// import PropTypes from 'prop-types'

const Checkbox = ({ name, text, def, onChange }) => {
  return (
    <div>
      <label>
        <input
          type="checkbox"
          name={text}
          id={name}
          defaultChecked={def}
          onChange={onChange}
        ></input>
        {text}
      </label>
    </div>
  );
};

export default Checkbox;
